import { Box, Collapse, Typography, IconButton } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./CohortCategoryCard.css";
import clockIcon from "../../assets/clock_img.svg";
import percentageIcon from "../../assets/percentage.svg";
import { MetricItem } from "../CohortBottomDrawer/CohortMetricItem";
import useTranslationSetup from "../../utils/useTranslationSetup";

const CohortCategoryCard = ({
  title,
  count,
  icon,
  isOpen,
  onToggle,
  children,
  className,
  cohortDetails,
  classNum,
}) => {
  const grade = Number(classNum);
  const { t } = useTranslationSetup();
  const ranges = cohortDetails?.rangesByGrade?.[grade] || {};
  const cwpmRange = ranges.cwpmRange || "N/A";
  const accuracyRange = ranges.accuracyRange || "N/A";
  return (
    <Box
      className={`cohort-category-card-container ${isOpen ? "container-expanded" : ""} ${className}-border`}
    >
      <Box
        className={`cohort-category-card ${isOpen ? "expanded" : ""} ${className}-bg`}
        onClick={onToggle}
      >
        <Box className="cohort-category-card-icon">
          <img src={icon} alt="Icon" className="cohort-card-icon" />
        </Box>
        <Box className="cohort-category-card-title">
          <Typography className="cohort-category-card-heading">
            {title}
          </Typography>
          <Typography className="cohort-card-count">
            {count} {t("students")}
          </Typography>
        </Box>
        <IconButton>
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {isOpen && (
        <Box className={`cohort-metric-wrapper ${className}-bg`}>
          <MetricItem
            icon={clockIcon}
            label={t("cwpm_metric_range")}
            value={cwpmRange}
            containerSx={{
              marginBottom: "4px !important",
            }}
            valueSx={{ fontSize: "14px !important" }}
          />
          {/* <MetricItem
            icon={percentageIcon}
            label={t("accuracy_range")}
            value={accuracyRange}
            containerSx={{
              marginBottom: "4px !important",
            }}
            valueSx={{ fontSize: "14px !important" }}
          /> */}
          {/* <MetricItem
            icon={soundWaveIcon}
            label={t("extra_accuracy_range")}
            value={extraAccuracyRange}
            containerSx={{
              marginBottom: "4px !important",
            }}
            valueSx={{ fontSize: "14px !important" }}
          /> */}
        </Box>
      )}

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box className="cohort-children-wrapper">{children}</Box>
      </Collapse>
    </Box>
  );
};

export default CohortCategoryCard;
